export const isFilled = (value: unknown): boolean => {
  if (value === null || value === undefined) return false;
  if (typeof value === 'string') return value !== '';
  if (typeof value === 'number') return value !== 0;
  if (typeof value === 'boolean') return true;
  if (Array.isArray(value)) return value.length > 0 && value.every(isFilled);
  if (typeof value === 'object') {
    const keys = Object.keys(value as Record<string, unknown>);
    if (keys.length === 0) return false;
    return keys.every((k) => isFilled((value as Record<string, unknown>)[k]));
  }
  return true;
};

export const isGroupComplete = (...values: unknown[]): boolean =>
  values.every(isFilled);
